export const IossCurrencies = ['GBP', 'EUR', 'USD'] as const;

export type IossCurrency = (typeof IossCurrencies)[number];

export type Currency = IossCurrency;
